var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#9DDDBA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1706 6.62161C14.2828 6.71202 14.3539 6.84263 14.3684 6.9847C14.3828 7.12678 14.3394 7.2687 14.2477 7.37924L9.32953 13.3025C9.28119 13.3607 9.22101 13.4083 9.15286 13.4422C9.08471 13.4761 9.0101 13.4956 8.93385 13.4993C8.8576 13.5031 8.7814 13.4911 8.71016 13.464C8.63892 13.437 8.57422 13.3955 8.52023 13.3423L5.78792 10.65C5.73573 10.6003 5.6941 10.5409 5.66546 10.4752C5.63682 10.4095 5.62174 10.3388 5.62111 10.2673C5.62048 10.1958 5.63431 10.1249 5.66179 10.0587C5.68926 9.99255 5.72984 9.93243 5.78115 9.88187C5.83246 9.83131 5.89347 9.79133 5.96063 9.76425C6.02779 9.73718 6.09974 9.72355 6.1723 9.72418C6.24486 9.7248 6.31657 9.73965 6.38324 9.76787C6.44991 9.79609 6.51021 9.83712 6.56062 9.88855L8.86614 12.1604L13.4018 6.69753C13.4935 6.58701 13.6261 6.51692 13.7702 6.50269C13.9144 6.48845 14.0584 6.53122 14.1706 6.62161Z",
    fill: "#FCFCFC",
    stroke: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.661f8445a306f797feee5cc9d5c2d347.svg";
export { ForwardRef as ReactComponent };